import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { ACC_ORDERS } from '@/store/entities/schema_types';
import { accOrdersClient as client } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters('accOrders'),
  actions: {
    ...resourceActions,
    async read(ctx, { id, query = {} }) {
      try {
        const response = await client.read(id, query);

        const { data } = response.data;

        await ctx.dispatch('entities/persistEntities', { type: ACC_ORDERS, data }, { root: true });

        return Promise.resolve(true);
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
  },
};
